import styled from "styled-components";
import { textTheme, colorTheme } from "../../../theme";

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  width: 100%;

  @media (min-width: 1442px) {
    display: flex;
    justify-content: center;
    margin-right: 230px;
  }
`;

export const InnerContent = styled.div`
  width: 1100px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-top: 20px;
`;

export const TileContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ChartsContainer = styled.div`
  // width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 75px;
`;

export const Chart = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChartTitle = styled.div`
  ${textTheme.h4}
  color: ${colorTheme.black};
  margin-bottom: 23px;
`;

export const TabContainer = styled.div`
  width: 490px;
  display: flex;
  gap: 20px;
  margin-bottom: 8px;
`;

export const Tab = styled.button<{ onClick: any; isSelected: boolean }>`
  ${textTheme.h4}
  border: none;
  padding: 0px;
  background-color: white;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.1px;
  color: ${props => (props.isSelected ? "#373f41;" : "#C3CBCD;")};
  &:hover {
    cursor: pointer;
  }
`;
